export default {
	title: 'Il mio profilo',
	messages: {
		choose_plan: 'Scegli un piano',
		unlock_immediately: 'Sblocca immediatamente tutte le funzionalità',
		current_subscription: 'La tua sottoscrizione attuale'
	},
	language: {
		title: 'Lingua',
		description: "Scegli la lingua dell'interfaccia",
		languages: {
			de: 'Tedesco',
			en: 'Inglese',
			es: 'Spagnolo',
			fr: 'Francese',
			hi: 'Hindi',
			it: 'Italiano',
			ja: 'Giapponese',
			pt: 'Portoghese',
			zh: 'Cinese (mandarino)'
		}
	},
	theme: {
		title: 'Selezione tema'
	},
	actions: {
		manage_subscription: 'Gestisci la mia sottoscrizione'
	},
	api_access: {
	  title: "Accesso API (server MCP)",
	  description: "Consente agli agenti IA (Claude, ChatGPT, ecc.) di accedere ai tuoi progetti Gerositus tramite il Model Context Protocol. Il token concede lo stesso accesso del tuo — mantienilo segreto.",
	  endpoint: "URL endpoint MCP",
	  no_token: "Ancora nessun token — generane uno per abilitare l'accesso degli agenti IA.",
	  default_token_name: "Token predefinito",
	  status_active: "Attivo",
	  status_revoked: "Revocato",
	  created_at: "Creato il {{date}}",
	  last_used_at: "Ultimo utilizzo il {{date}}",
	  never_used: "Mai utilizzato",
	  generate: "Genera token",
	  regenerate: "Rinnova token",
	  revoke: "Revoca token",
	  copy: "Copia",
	  copied: "Copiato negli appunti",
	  copy_failed: "Copia non riuscita",
	  config_example: "Esempio di configurazione client MCP",
	  reveal_title: "Salva subito il tuo token",
	  reveal_done: "L'ho salvato",
	  reveal_warning_title: "Questa è l'unica volta che vedrai questo token",
	  reveal_warning_body: "Copialo in un posto sicuro (gestore di password). Se lo perdi, dovrai rinnovarlo. Chiunque possieda questo token può leggere i tuoi progetti.",
	  regenerate_confirm_title: "Rinnovare il token di accesso?",
	  regenerate_confirm_body: "Il token attuale verrà revocato immediatamente e ne verrà emesso uno nuovo. Gli agenti IA che usano il vecchio token andranno riconfigurati.",
	  revoke_confirm_title: "Revocare il token di accesso?",
	  revoke_confirm_body: "Gli agenti IA che usano questo token perderanno l'accesso. Puoi generarne uno nuovo in qualsiasi momento."
	}
};
